'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.AccordionHeadingLevels = void 0;
(function(AccordionHeadingLevels) {
    AccordionHeadingLevels["H1"] = 'h1';
    AccordionHeadingLevels["H2"] = 'h2';
    AccordionHeadingLevels["H3"] = 'h3';
    AccordionHeadingLevels["H4"] = 'h4';
    AccordionHeadingLevels["H5"] = 'h5';
    AccordionHeadingLevels["H6"] = 'h6';
})(exports.AccordionHeadingLevels || (exports.AccordionHeadingLevels = {}));
exports.AccordionHeaderContentPositions = void 0;
(function(AccordionHeaderContentPositions) {
    AccordionHeaderContentPositions["After"] = 'after';
    AccordionHeaderContentPositions["Before"] = 'before';
})(exports.AccordionHeaderContentPositions || (exports.AccordionHeaderContentPositions = {}));
exports.AccordionButtonIconPositions = void 0;
(function(AccordionButtonIconPositions) {
    AccordionButtonIconPositions["After"] = 'after';
    AccordionButtonIconPositions["Before"] = 'before';
})(exports.AccordionButtonIconPositions || (exports.AccordionButtonIconPositions = {}));
exports.AccordionAnimations = void 0;
(function(AccordionAnimations) {
    AccordionAnimations["FadeIn"] = 'fadeIn';
    AccordionAnimations["FadeInFromTop"] = 'fadeInFromTop';
})(exports.AccordionAnimations || (exports.AccordionAnimations = {}));
//# sourceMappingURL=accordion.js.map
